export default function validation(response, messages, i18n, translate) {
  response.data.error.validationErrors.forEach((error) => {
    let champs = 0;
    if (error.members) {
      champs = error.members[0];
      if (translate) champs = translate(i18n, champs);
    }
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('The field Commissions must be a string or array ') !== -1) {
        messages.push({
          message: 'addEditMarche.error.fournisseurObligatoire',
          parametres: {
            name: champs,
          },
        });
      }
      if (message.indexOf('ONLY_ONE_COMMISSION_PER_PROVIDER') === 0) {
        messages.push({
          message: 'addEditMarche.error.onlyOne',
        });
      }
      if (message.indexOf('SUM_MUST_BE_100') === 0) {
        messages.push({
          message: 'addEditMarche.error.sumMustBeOneHundred',
        });
      }
      if (message.indexOf('Error converting value {null}') !== -1) {
        messages.push({
          message: 'addEditMarche.error.champsObligatoire',
          parametres: {
            name: champs,
          },
        });
      }
    }
  });
}
